export const PRODUCT_DETAIL_FIELD = {
  title: 'title',
  author: 'author',
  doi: 'doi',
  publishedYear: 'publishedYear',
  conference: 'conference',
  ISSN_ISBN: 'ISSN_ISBN',
  rank: 'rank',
  patentCode: 'patentCode',
  object: 'object',
  note: 'note',
};
export const KPI_GROUP = [
  'K1',
  'K2',
  'K3',
  'K4',
  'K5',
  'K6',
  'K7',
  'K8',
  'K9',
  'K10',
  'K11',
  'K12',
];
export const PRODUCT_TYPE = {
  HARD_PRODUCT: {
    code: 'hardProduct',
    short: 'SPC',
    kpiGroups: KPI_GROUP,
  },
  SOFT_PRODUCT: {
    code: 'softProduct',
    short: 'SPM',
    kpiGroups: KPI_GROUP,
  },
  SCIENTIFIC_PUBLICATION: {
    code: 'scientificPublication',
    short: 'APKH',
    kpiGroups: KPI_GROUP,
  },
  INTELLECTUAL_PROPERTY: {
    code: 'intellectualProperty',
    short: 'SHTT',
    kpiGroups: ['K7', 'K8', 'K9'],
  },
  TRAINING_RESULT: {
    code: 'trainingResult',
    short: 'SPDT',
    kpiGroups: ['K11', 'K12'],
  },
  TECHNOLOGY_TRANSFER: {
    code: 'technologyTransfer',
    short: 'CGCN',
    kpiGroups: ['K10'],
  },
  findKpiGroupsByShort(shortCode) {
    const product = Object.values(PRODUCT_TYPE).find((p) => p.short === shortCode);
    return product ? product.kpiGroups : null;
  },
};

export const PRODUCT_TYPE_2025 = {
  SCIENTIFIC_PUBLICATION: {
    code: 'scientificPublication',
    short: 'APKH',
    kpiGroups: ['K1', 'K2', 'K3', 'K4', 'K5'],
  },
  INTELLECTUAL_PROPERTY: {
    code: 'intellectualProperty',
    short: 'SHTT',
    kpiGroups: ['K6', 'K7'],
  },
  TRAINING_RESULT: {
    code: 'trainingResult',
    short: 'SPDT',
    kpiGroups: ['K8'],
  },
  TECHNOLOGY_TRANSFER: {
    code: 'technologyTransfer',
    short: 'CGCN',
    kpiGroups: ['K9', 'K10', 'K11', 'K12', 'K13', 'K14'],
  },
  findKpiGroupsByShort(shortCode) {
    const product = Object.values(PRODUCT_TYPE_2025).find((p) => p.short === shortCode);
    return product ? product.kpiGroups : null;
  },
};

export const SUMMARY_REPORT_FIELD = {
  title: 'title',
  author: 'author',
  doi: 'doi',
  publishedYear: 'publishedYear',
  conference: 'conference',
  ISSN_ISBN: 'ISSN_ISBN',
  rank: 'rank',
  patentCode: 'patentCode',
  object: 'object',
  note: 'note',
};

export const SMR = {
  PRODUCT_DETAIL_FIELD,
  PRODUCT_TYPE,
  KPI_GROUP,
  SUMMARY_REPORT_FIELD,
};

export const ASYNC_CONSTANT = {
  EACH_LIMIT: 10,
  NUMBER_PRODUCT: 5,
};
